import { IconPen, IconPlusRounded, IconTrash } from "@aksara-ui/icons";
import {
  Badge,
  Box,
  Button,
  Card,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import {
  getAllHelpCenters,
  setModalConfirmationOpen,
  setModalFormOpen,
} from "redux/actions";
import styled from "styled-components";
import { HelpCenterConfirmationModal, HelpCenterFormModal } from "./components";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const HelpCentersContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });

  const { isLoading, isModalFormOpen, isModalConfirmationOpen } = useSelector(
    (state: any) => state.globalReducer
  );
  const { helpCenters } = useSelector((state: any) => state.helpCenterReducer);

  const [selectedHelpCenterId, setSelectedHelpCenterId] = useState("");

  const handleOpenFormModal = (helpCenterId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedHelpCenterId(helpCenterId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedHelpCenterId("");
  };

  const handleOpenConfirmModal = (helpCenterId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedHelpCenterId(helpCenterId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedHelpCenterId("");
  };

  useEffect(() => {
    // if (!helpCenters.length) {
    dispatch(getAllHelpCenters() as any);
    // }
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "left" : "center"}
      >
        <Box display="flex">
          <Text scale={[500, 600]} fontWeight={700}>
            Help Centers
          </Text>
        </Box>

        <Box display="flex">
          <Stack display="flex" flexDirection="row" style={{ gap: 10 }}>
            <Button
              variant="primary"
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition="left"
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Help Center
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead position={"sticky"} top={0} backgroundColor={"white"}>
            <TableHeadRow>
              <TableHeadCell>Title</TableHeadCell>
              <TableHeadCell>Link</TableHeadCell>
              <TableHeadCell>Active</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={4} />
            ) : !helpCenters.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={4} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              helpCenters.map((helpCenter: any) => {
                return (
                  <TableBodyRow key={helpCenter.id}>
                    <TableBodyCell>{helpCenter.title}</TableBodyCell>
                    <TableBodyCell>{helpCenter.link}</TableBodyCell>
                    <TableBodyCell whiteSpace={"nowrap"}>
                      <Badge
                        size="md"
                        variant={
                          helpCenter.is_active === 1 ? "success" : "critical"
                        }
                      >
                        {helpCenter.is_active === 1 ? "Active" : "Non Active"}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        onClick={() => handleOpenFormModal(helpCenter.id)}
                      >
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(helpCenter.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>

      <HelpCenterFormModal
        helpCenterId={selectedHelpCenterId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <HelpCenterConfirmationModal
        helpCenterId={selectedHelpCenterId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />
    </Box>
  );
};

export default HelpCentersContent;
